import {inject, Injectable} from '@angular/core';
import {Collection} from '../collection.model';
import {Observable} from 'rxjs';
import {CollectionItem} from '../../collection-item/collection-item.model';
import {endpoints} from '../../../core/configs/endpoints';
import {HttpService} from '../../../core/http/http.service';

/**
 * Service to interact with the Collection API.
 * Provides methods to retrieve, create, and delete user collections.
 */
@Injectable({providedIn: 'root'})
export class CollectionApiService {
  private readonly _httpClient = inject(HttpService)


  /**
   * Retrieves the collection of a specific user.
   * @returns An Observable emitting the user's collection.
   */
  public getCollection(): Observable<Collection | null> {
    return this._httpClient.get<Collection>(endpoints.collection.list);
  }

  public scanQrCheck(barcode: string) {
    return this._httpClient.get<CollectionItem>(endpoints.qrCode.scan(barcode));
  }

  public assignCollectionItem(token: string, massiveAssign?: boolean): Observable<any> {
    return this._httpClient.post(`${endpoints.collection_item.assign}`, {token: token, massiveAssign});
  }
}
